webpackJsonp([170384593892729],{

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//const Image = styled.img`
	//  display: block;
	//  max-width: 100%;
	//  transition: 175ms ease-in-out;
	//`
	
	var ImageShift = function (_Component) {
	  _inherits(ImageShift, _Component);
	
	  function ImageShift(props) {
	    _classCallCheck(this, ImageShift);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      mounted: false
	    };
	    return _this;
	  }
	
	  ImageShift.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      mounted: true
	    });
	  };
	
	  ImageShift.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        mounted = _props.mounted,
	        color = _props.color,
	        className = _props.className;
	
	    var classT = className;
	    if (mounted) {
	      classT = "image-loading";
	    }
	    if (color) {
	      classT = classT + " background-color-" + color;
	    }
	    //<img src={src} className={ mounted &&
	    //        "image-loading"} />
	    return _react2.default.createElement("img", { src: src, className: classT, alt: alt });
	  };
	
	  return ImageShift;
	}(_react.Component);
	
	exports.default = ImageShift;
	module.exports = exports["default"];

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLanding = __webpack_require__(9);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	var _ImageShift = __webpack_require__(15);
	
	var _ImageShift2 = _interopRequireDefault(_ImageShift);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { Grid, Row, Col } from 'react-flexbox-grid';
	
	//import win from '../assets/images/windows.png';
	//import linux from '../assets/images/linux.png';
	
	var pageTitle = "Mon CV en ligne";
	//const pageContent = ["Parmis les compétences ci-dessous,", "j'assure installation, configuration et administration","d'équipements et / ou de services"];
	var pageContent = ['Page en cours de construction !'];
	var Generic = function Generic(props) {
	    return _react2.default.createElement(
	        'div',
	        { style: props.transition && props.transition.style },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Web2alpes - ',
	                pageTitle
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Mon parcours professionnel et formation' })
	        ),
	        _react2.default.createElement(_BannerLanding2.default, { title: pageTitle, color: 'style-logo-lg', particles: 'infra', content: pageContent }),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { className: 'tiles-full' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'comptetences' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'spotlights' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'header',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _react2.default.createElement('i', { className: 'icon alt fa-sitemap' }),
	                                        ' Reseaux'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'snow' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration r\xE9seaux niveau 2 et 3 (routeurs, switchs, Wifi de toute marque HP / Cisco / Nortel / Netgear / Dlink / AlliedTelesyn ...),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration r\xE9seaux wifi (hotspot / r\xE9seaux d\'entreprises...)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Maitrise des protocoles r\xE9seaux de base IPv4 & IPv6, Vlan, Spanning tree, Qos , Ha, Ospf, Bgp, Olsr, Vrf'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration de services r\xE9seaux (Dns, Dhcp, Radius, Remote logging, NTP, Proxy...),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Interconnexion site \xE0 site'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'D\xE9finition architecture LAN / MAN / WLAN,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Mise en \u0153uvre de mont\xE9es de version des \xE9quipements ou services r\xE9seaux,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'D\xE9fintion de configurations types des \xE9quipements (switch, routeurs..),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'D\xE9finition de proc\xE9dures d\'exploitation pour tous les \xE9quipements et services mises en place'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Suivi et gestion des performances (seuil d\u2019alerte et optimisation (tuning)\u2026).'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'header',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _react2.default.createElement('i', { className: 'icon alt fa-shield' }),
	                                        ' Securite'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'snow' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'S\xE9curisation serveurs (Windows / Linux) et postes de travail,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Mise en place de sauvegarde informatique,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Mise en place de liaisons priv\xE9es virtuelles (VPN IPSec / SSL),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration de Firewall (Iptables, Ebtables, Netasq, Stormshield, Cisco),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration Syt\xE8mes de d\xE9tection ou de protection IPS, IDS (snort, suricata),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'R\xE9alisation d\'audits : D\xE9tection d\'intrusions et de vuln\xE9rabilit\xE9s via des outils adapt\xE9s : Metasploit, Ettercap, Openvas et Nessus,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration de syst\xE8mes de supervision : Nagios, Centreon, Cacti, Prtg, Eye of network,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration de serveurs WEB : Apache2, Nginx avec WAF (ModSecurity / Naxsi / DenyAll Isuite (ex beeware),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Mise en place de m\xE9canismes de haute disponibilit\xE9 syt\xE8mes et r\xE9seau (cluster base de donn\xE9es, r\xE9partition de charge sur le r\xE9seau),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Accompagnement dans l\'\xE9laboration d\'un plan de reprise ou de continuit\xE9 d\'activit\xE9 (PCA / PRA).'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'spotlights' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'header',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _react2.default.createElement('i', { className: 'icon alt fa-windows' }),
	                                        ' Windows'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'snow' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration Windows Server 2008/2012/2016,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Mise en place d\'environnements de s\xE9curit\xE9 dynamique pour prot\xE9ger vos donn\xE9es,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Optimisation et surveiller les performances du syst\xE8me,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Supervision adapt\xE9e aux services install\xE9s (SNMP / WMI).'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Mise en place de domaines Active Directory'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Gestion des mises \xE0 jour dans un environement domaine'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Mise en place de strat\xE9gies de groupe (GPO)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Deploiement via le r\xE9seau d\'images poste de travail.'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'header',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _react2.default.createElement('i', { className: 'icon alt fa-linux' }),
	                                        ' Linux'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'snow' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration de serveurs LINUX ( Debian / Ubuntu / Centos / Redhat),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Deploiement de tous types de services,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Gestion des environnements de d\xE9veloppement, de pr\xE9-production et de production,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Supervision adapt\xE9e aux services install\xE9s sur les serveurs (SNMP / Shell / Nagios),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'D\xE9veloppement de solutions d\'installation et de d\xE9ploiement de serveurs (Ansible/shell),'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Analyse et expertise des probl\xE8mes potentiels li\xE9s \xE0 l\'architecture et proposition de solutions ad\xE9quates.'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'spotlights' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'header',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _react2.default.createElement('i', { className: 'icon alt fa-cloud' }),
	                                        ' Virtualisation'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'snow' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration de fermes VMware, Xen et KVM, '
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Optimisation des performances des syst\xE8mes d\u2019exploitation (tuning),'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'header',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _react2.default.createElement('i', { className: 'icon alt fa-database' }),
	                                        ' Stockage'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'snow' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Installation, configuration et administration de dispositifs de stockage NAS / SAN,'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Configuration raid sp\xE9cifique'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'spotlights' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text' },
	                            _react2.default.createElement(
	                                'header',
	                                null,
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement('i', { className: 'icon alt fa-database' }),
	                                    ' Bases de donnees'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'snow' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Installation, configuration et administration de bases de donn\xE9es relationnelles Sql / Mysql / Mariadb / PostgresSql'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Installation, configuration et administration de bases de donn\xE9es objet nosql comme Mongodb / Datastax'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Mise en place de clusters de base de donn\xE9es (Mysql et Mongodb)'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text' },
	                            _react2.default.createElement(
	                                'header',
	                                null,
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    _react2.default.createElement('i', { className: 'icon alt fa-sitemap' }),
	                                    ' Developpement'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'snow' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Scripting : Bash / Shell / Powershell'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Perl / Python'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Web : HTML5 / Javascript / NodeJs / AngularJs / ReactJs / PHP'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Java avanc\xE9'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'header',
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                _react2.default.createElement('i', { className: 'icon alt fa-road' }),
	                                ' Parcours professionnel'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'spotlights' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '2016-2018 : Ingenieur reseaux et securite'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'La Metro - Grenoble'
	                                ),
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '2009-2016 : Ingenieur systemes, reseaux et securite'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Ville de Grenoble'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '2006-2009 : Ingenieur systemes, reseaux'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Alternance - Agglomeration de Montbeliard'
	                                ),
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '2004-2006 : Technicien informatique en alternance'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Alternance - Agglomeration de Montbeliard'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'header',
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                _react2.default.createElement('i', { className: 'icon alt fa-graduation-cap' }),
	                                ' Formations'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'spotlights' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '2011 : Mise a niveau Windows 7/2008'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'IB Formation, Lyon'
	                                ),
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '2006-2009 : CNAM \u2013 Ingenieurs 2000'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Sp\xE9cialit\xE9 informatique et r\xE9seaux, Champs-sur-Marne'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '2004-2006 : DUT Telecom et reseaux'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Alternance, IUT Belfort-Montb\xE9liard'
	                                ),
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '2003-2004 : Administrateur systemes et reseaux Windows 2003'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Soci\xE9t\xE9 Expertease, Strasbourg'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cv-js-965e60c19658a59852ad.js